import $ from "jquery";
import "slick-carousel";

import './animations/_loader';
import './utils/_lazyload';
//import './animations/_aos';
$("a[href*='#']:not([href='#'])").click(function() {
    if (
        location.hostname == this.hostname &&
        this.pathname.replace(/^\//, "") == location.pathname.replace(/^\//, "")
    ) {
        var anchor = $(this.hash);
        anchor = anchor.length ? anchor : $("[name=" + this.hash.slice(1) + "]");
        if (anchor.length) {
            $("html, body").animate({ scrollTop: anchor.offset().top }, 1500);
        }
    }
});
$('.realisations-slider > ul').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    infinite: true,
    responsive: [{
        breakpoint: 768,
        settings: {
            arrows: false,
        }
    }]
});
$('#home-slider .slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    infinite: true,
    appendArrows: "#home-slider .container",
    appendDots: "#home-slider .container",
    responsive: [{
        breakpoint: 768,
        settings: {
            arrows: false,
        }
    }]
});
$('.realisations-thumbs img').click((e) => {
    e.preventDefault();
    let pos = $(e.target).attr('data-position');
    $('.realisations-slider > ul').slick('slickGoTo', pos);
})
$('.realisations-slider > ul').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    infinite: true,
    responsive: [{
        breakpoint: 768,
        settings: {
            arrows: false,
        }
    }]
});

$('.reals-block').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    responsive: [{
        breakpoint: 768,
        settings: {
            arrows: false,
        }
    }]
});

$('#clients-holder.slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    mobileFirst: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
            }
        },
        {
            breakpoint: 1280,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true,
            }
        }
    ]
});

$('#post-holder.slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    mobileFirst: true,
    responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
            }
        }
    ]
});



jQuery(function($) { // use jQuery code inside this to avoid "$ is not defined" error
    $('.loadmore-trigger .button').click(function() {

        var button = $(this),
            data = {
                'action': 'load_more',
                'query': button.data('posts'),
                'page': button.data('current')
            };

        $.ajax({ // you can also use $.post here
            url: "/wp-admin/admin-ajax.php", // AJAX handler
            data: data,
            type: 'POST',
            beforeSend: function(xhr) {
                button.html('<i class="fas fa-spinner fa-spin fa-2x"></i>'); // change the button text, you can also add a preloader image
            },
            success: function(data) {
                if (data) {
                    $(button.data("to")).append(data);
                    button.text(button.data("text")) // insert new posts
                    button.data('current', button.data('current') + 1)

                    if (button.data('current') == button.data('total'))
                        button.closest(".loadmore-trigger").remove(); // if last page, remove the button

                    // you can also fire the "post-load" event here if you use a plugin that requires it
                    // $( document.body ).trigger( 'post-load' );
                } else {
                    button.closest(".loadmore-trigger").remove(); // if last page, remove the button
                }
            }
        });
    });
});


// WEBPACK FOOTER //
// ./assets/scripts/global.js